
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { User, Calendar, Star } from "lucide-react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "@/contexts/AuthContext";
import UpcomingSessionsModule from "@/components/patient/UpcomingSessionsModule";
import SessionsHistoryModule from "@/components/patient/SessionsHistoryModule";
import ProfileEditModule from "@/components/patient/ProfileEditModule";

const PatientDashboard = () => {
  const [activeTab, setActiveTab] = useState("upcoming");
  const { profile } = useAuth();

  const handleRefresh = () => {
    // Função para refresh - pode ser expandida conforme necessário
    window.location.reload();
  };

  return (
    <>
      <Helmet>
        <title>Dashboard do Paciente | PsiOnline</title>
        <meta name="description" content="Gerencie suas consultas e perfil" />
      </Helmet>

      <div className="space-y-6">
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-3xl font-bold">Seu Dashboard</h1>
            <p className="text-muted-foreground">
              Olá, {profile?.full_name || profile?.first_name || "paciente"}! Gerencie suas consultas e perfil aqui.
            </p>
          </div>
          <Button asChild variant="outline">
            <Link to="/patient/profile">
              <User className="mr-2 h-4 w-4" />
              Editar Perfil
            </Link>
          </Button>
        </div>

        {/* Stats Cards - Removido "Total Investido" */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">Sessões Concluídas</CardTitle>
              <Calendar className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">12</div>
              <p className="text-xs text-muted-foreground">
                +2 desde o mês passado
              </p>
            </CardContent>
          </Card>
          
          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">Próximas Sessões</CardTitle>
              <Calendar className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">3</div>
              <p className="text-xs text-muted-foreground">
                Agendadas para esta semana
              </p>
            </CardContent>
          </Card>
        </div>

        <Tabs 
          defaultValue="upcoming" 
          className="w-full"
          value={activeTab}
          onValueChange={setActiveTab}
        >
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="upcoming">Próximas Sessões</TabsTrigger>
            <TabsTrigger value="history">Histórico</TabsTrigger>
            <TabsTrigger value="profile">Meu Perfil</TabsTrigger>
          </TabsList>
          
          <TabsContent value="upcoming" className="space-y-4 pt-4">
            <UpcomingSessionsModule onRefresh={handleRefresh} />
          </TabsContent>
          
          <TabsContent value="history" className="space-y-4 pt-4">
            <SessionsHistoryModule />
          </TabsContent>
          
          <TabsContent value="profile" className="space-y-4 pt-4">
            <ProfileEditModule />
          </TabsContent>
        </Tabs>
      </div>
    </>
  );
};

export default PatientDashboard;
